<template>
  <file-card
    ref="$modal"
    @on-close="isActive = false"
    :position="safePosition"
    :loading="isLoading"
    height="auto"
    width="235px"
  >
    <div class="contact-info">
      <template v-if="type == 'move'">
        <div class="contact-info__header">Переместить элементы?</div>
        <div class="contact-info__field">
          <div class="contact-info__field--text">
            Вы собираетесь перенести
            <span class="contact-info__field--text-weight"> {{ label }} </span>
            в папку
            <span class="contact-info__field--text-weight">
              {{ targetDir?.Name }}
            </span>
          </div>
          <div class="contact-info__field--buttons">
            <app-button type="secondary" label="Отмена" @click="onClose" />
            <app-button type="primary" label="Подтвердить" @click="success" />
          </div>
        </div>
      </template>
      <template v-if="type == 'replace'">
        <div class="contact-info__header">Замена файла</div>
        <div class="contact-info__field">
          <div class="contact-info__field-radio">
            <app-radio-button
              v-model="selectedReplaceOption"
              text="Оставить текущее название"
              name="answer"
              :radio-value="true"
            />
            <app-radio-button
              v-model="selectedReplaceOption"
              text="Применить новое название"
              name="answer"
              :radio-value="false"
            />
          </div>
          <div
            class="contact-info__field--buttons"
            style="justify-content: center"
          >
            <app-button type="secondary" label="Отмена" @click="onClose" />
            <app-button type="primary" label="Заменить" @click="success" />
          </div>
        </div>
      </template>
      <template v-if="type == 'replaceUpload'">
        <div class="contact-info__header">
          Файл с таким названием уже существует
        </div>
        <div class="contact-info__field">
          <div class="contact-info__field-radio">
            <app-radio-button
              v-model="selectedReplaceOption"
              text="Заменить файл"
              name="answer"
              :radio-value="true"
            />
            <app-radio-button
              v-model="selectedReplaceOption"
              text="Оставить обе версии"
              name="answer"
              :radio-value="false"
            />
          </div>
          <div class="contact-info__field--buttons">
            <app-button type="secondary" label="Отмена" @click="onClose" />
            <app-button type="primary" label="Подтвердить" @click="success" />
          </div>
        </div>
      </template>
      <template v-if="type == 'error'">
        <div class="contact-info__header">Ошибка</div>
        <div class="contact-info__field">
          <div
            style="align-self: center; max-width: 204px"
            class="contact-info__field--text"
          >
            {{ errorText }}
          </div>
          <div style="align-self: center" class="contact-info__field--buttons">
            <app-button type="primary" label="Ок" @click="success" />
          </div>
        </div>
      </template>
      <template v-if="type == 'remove'">
        <div class="contact-info__header">Удалить элементы?</div>
        <div class="contact-info__field">
          <div class="contact-info__field--text">
            Вы собираетесь удалить
            <span class="contact-info__field--text-weight">
              {{ label }}
            </span>
          </div>
          <div class="contact-info__field--buttons">
            <app-button type="secondary" label="Отмена" @click="onClose" />
            <app-button type="primary" label="Подтвердить" @click="success" />
          </div>
        </div>
      </template>
      <template v-if="type == 'removeFile'">
        <div class="contact-info__header">Удалить файл?</div>
        <div class="contact-info__field">
          <div class="contact-info__field--text">
            Вы собираетесь удалить файл
            <span class="contact-info__field--text-weight">
              {{ targetFile?.Name
              }}<span
                v-if="targetFile?.JobBindings.length > 0"
                style="font-weight: 400; color: #4d4d4d"
                >.</span
              >
            </span>
            {{
              targetFile?.JobBindings.length > 0
                ? targetFile?.JobBindings.length > 1
                  ? `Он прикреплён ${targetFile?.JobBindings.length} ${
                      targetFile?.JobBindings.length % 10 == 1 &&
                      targetFile?.JobBindings.length !== 11
                        ? "работе"
                        : "работам"
                    }.`
                  : "Он прикреплён к работе."
                : ""
            }}
          </div>
          <div class="contact-info__field--buttons">
            <app-button type="secondary" label="Отмена" @click="onClose" />
            <app-button type="primary" label="Подтвердить" @click="success" />
          </div>
        </div>
      </template>
      <template v-if="type == 'removeFolder'">
        <div class="contact-info__header">Удалить папку?</div>
        <div class="contact-info__field">
          <div class="contact-info__field--text">
            Вы собираетесь удалить папку
            <span class="contact-info__field--text-weight">
              {{ targetDir?.Name }}
            </span>
          </div>
          <div class="contact-info__field--buttons">
            <app-button type="secondary" label="Отмена" @click="onClose" />
            <app-button type="primary" label="Подтвердить" @click="success" />
          </div>
        </div>
      </template>
      <template v-if="type == 'abortFile'">
        <div class="contact-info__header">Прервать загрузку?</div>
        <div class="contact-info__field">
          <div class="contact-info__field--text">
            Вы собираетесь прервать загрузку файла
            <span class="contact-info__field--text-weight">
              {{ targetFile?.Name }}
            </span>
          </div>
          <div class="contact-info__field--buttons">
            <app-button type="secondary" label="Отмена" @click="onClose" />
            <app-button type="primary" label="Подтвердить" @click="success" />
          </div>
        </div>
      </template>
    </div>
  </file-card>
</template>

<script setup lang="ts">
import FileCard from "./FileCard.vue";
import FileString from "../FileString.vue";
import { computed, nextTick, onMounted, onUnmounted, ref, watch } from "vue";
import AppButton from "@/components/ui-kit/button/AppButton.vue";
import AppRadioButton from "@/components/ui-kit/radio-button/AppRadioButton.vue";
import {
  FileInfoContainer,
  FileOut,
  FolderOut,
} from "@/models/interfaces/file/file-model";

const emit = defineEmits([
  "successMove",
  "successReplace",
  "successReplaceUpload",
  "successRemove",
  "successRemoveFile",
  "successRemoveFolder",
  "successAbortFile",
  "closeError",
]);

type ModalPosition = { x: number; y: number };

const selectedReplaceOption = ref<boolean>(true);

const $modal = ref<InstanceType<typeof FileCard> | null>(null);
const isLoading = ref(false);
const isActive = ref(false);
const targetDir = ref<FolderOut>();
const targetFile = ref<FileOut>();
const countEl = ref();
const errorText = ref("");
const replaceFile = [
  { text: "Оставить текущее название", value: false },
  { text: "Применить новое название", value: false },
];

interface Props {
  type?:
    | "replace"
    | "move"
    | "error"
    | "replaceUpload"
    | "remove"
    | "removeFile"
    | "removeFolder"
    | "abortFile";
  errorType?: string;
  position?: ModalPosition | null;
  // files?: FileOut[];
}

const props = withDefaults(defineProps<Props>(), {
  type: "move",
  errorType: "size",
});

const pluralize = (
  n: number,
  one: string,
  few: string,
  many: string,
): string => {
  const abs = Math.abs(n) % 100;
  const mod10 = abs % 10;
  if (abs >= 11 && abs <= 19) return many;
  if (mod10 === 1) return one;
  if (mod10 >= 2 && mod10 <= 4) return few;
  return many;
};

const label = computed(() => {
  const n = countEl.value ?? 0;
  return `${n} ${pluralize(n, "элемент", "элемента", "элементов")}`;
});

const MODAL_WIDTH = 235;
const MODAL_HEIGHT_FALLBACK = 160;
const MODAL_MARGIN = 8;

const getCenteredPosition = (): ModalPosition => ({
  x: window.scrollX + (window.innerWidth - MODAL_WIDTH) / 2,
  y: window.scrollY + (window.innerHeight - MODAL_HEIGHT_FALLBACK) / 2,
});

const safePosition = computed<ModalPosition>(() => {
  const raw = props.position;

  const position =
    raw &&
    Number.isFinite(raw.x) &&
    Number.isFinite(raw.y) &&
    !(raw.x === 0 && raw.y === 0)
      ? raw
      : getCenteredPosition();

  const minX = window.scrollX + MODAL_MARGIN;
  const minY = window.scrollY + MODAL_MARGIN;

  const maxX = window.scrollX + window.innerWidth - MODAL_WIDTH - MODAL_MARGIN;

  const maxY =
    window.scrollY + window.innerHeight - MODAL_HEIGHT_FALLBACK - MODAL_MARGIN;

  return {
    x: Math.min(Math.max(position.x, minX), maxX),
    y: Math.min(Math.max(position.y, minY), maxY),
  };
});

const success = () => {
  switch (props.type) {
    case "replace":
      emit("successReplace", selectedReplaceOption.value);
      $modal.value?.onClose();
      break;

    case "move":
      emit("successMove", targetDir.value);
      $modal.value?.onClose();
      break;

    case "replaceUpload":
      emit("successReplaceUpload", selectedReplaceOption.value);
      $modal.value?.onClose();
      break;

    case "remove":
      emit("successRemove");
      $modal.value?.onClose();
      break;

    case "removeFile":
      emit("successRemoveFile", targetDir.value, targetFile.value);
      $modal.value?.onClose();
      break;

    case "removeFolder":
      emit("successRemoveFolder", targetDir.value);
      $modal.value?.onClose();
      break;

    case "abortFile":
      emit("successAbortFile");
      $modal.value?.onClose();
      break;

    case "error":
      emit("closeError");
      $modal.value?.onClose();
      break;
  }

  $modal.value?.onClose();
};

const chooseError = () => {
  switch (props.errorType) {
    case "size":
      errorText.value = "Размер файла не должен превышать 100 Мб";
      break;

    case "extension":
      errorText.value = "Форматы файлов не совпадают";
      break;

    case "folder":
      errorText.value = "Вы не можете добавить внешнюю папку";
      break;

    case "notFound":
      errorText.value = "Файл не найден";
      break;

    case "folderNameMatch":
      errorText.value = "Папка с таким названием уже существует";
      break;

    case "fileNameMatch":
      errorText.value = "Файл с таким названием уже существует";
      break;

    case "chooseAccessDenied":
      errorText.value =
        "Вы не можете выбрать папку целиком, потому что у вас нет доступа к некоторым файлам";
      break;
  }

  // $modal.value?.onClose();
};

onMounted(() => {
  window.addEventListener("keydown", handleEsc, true);
});

onUnmounted(() => {
  window.removeEventListener("keydown", handleEsc, true);
});

const handleEsc = async (e: KeyboardEvent) => {
  if (e.key !== "Escape") {
		return
  }
  if (!isActive.value) {
		return
  }

  e.stopPropagation();
  $modal.value?.onClose();
};

const onClose = () => {
  isActive.value = false;
  $modal.value?.onClose();
};

const onOpen = async (dir?: FolderOut, count?: number, file?: FileOut) => {
  try {
    $modal.value?.onOpen();
    isActive.value = true;

    await nextTick();

    targetDir.value = dir;
    targetFile.value = file;
    countEl.value = count;

    if (props.type == "error") {
      chooseError();
    }
  } catch (e) {
    console.error(e);
  }
};

defineExpose({ onOpen, onClose });
</script>

<style scoped lang="scss">
@import "@/styles/color.scss";

.contact-info {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 6px;
  gap: 8px;

  &-modal {
    padding: 12px;
    gap: 16px;
  }

  &__header {
    display: flex;
    text-align: center;
    width: 100%;
    gap: 8px;
    justify-content: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0%;
    color: $color-text_main;
  }

  &__field {
    font-size: 14px;
    line-height: 18px;
    color: $color-text_main;
    flex-direction: column;
    display: flex;
    gap: 10px;

    &-radio {
      display: flex;
      flex-direction: column;
      gap: 2px;
    }

    &--text {
      text-align: center;
      display: inline-block;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0%;
      font-weight: 400;
      color: $color-text_main;

      &-weight {
        font-weight: 500;
        color: $color-text_main;
        font-size: 14px;
        line-height: 18px;
      }
    }

    &--buttons {
      display: flex;
      gap: 8px;

      &-weight {
        font-weight: 500;
      }
    }

    &--col {
      display: flex;
      flex-direction: column;
    }

    &-name {
      font-weight: 500;
    }

    &-value-col {
      display: inline-flex;
      align-items: center;
      &-time {
        color: #979797;
      }

      &-action {
        margin-left: 2px;
      }

      &-show-more {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 16px;
        padding: 2px 4px;
        font-size: 10px;
        border-radius: 8px;
        margin-left: 6px;
        margin-top: 1px;
        background-color: #f2f2f2;
        color: #979797;
        cursor: pointer;
      }

      &-link {
        font-size: 14px;
        line-height: 16px;
        color: #499259;
        text-decoration: none;
        margin-bottom: 4px;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
